const BASE_URL = process.env.REACT_APP_API_BASE_URL || "";

export type OtpPurpose = "login" | "signup" | "password_reset";

export class AuthApiError extends Error {
  constructor(
    message: string,
    public status: number,
    public type?: string,
    public fields?: Record<string, string[] | string>,
  ) {
    super(message);
  }
}

async function request<T>(path: string, body: Record<string, unknown>): Promise<T> {
  const response = await fetch(`${BASE_URL}${path}`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const result = await response.json().catch(() => ({}));

  if (!response.ok) {
    const error = result?.error ?? result;
    throw new AuthApiError(
      error?.message ?? result?.message ?? "خطایی رخ داد. لطفاً دوباره تلاش کنید.",
      response.status,
      error?.type,
      error?.fields,
    );
  }

  return result as T;
}

export const passwordLogin = (data: { username_or_email: string; password: string }) =>
  request<Record<string, any>>("/api/users/login/", data);

export const requestOtp = (mobile: string, purpose: OtpPurpose) =>
  request<{ success?: boolean; data?: { expires_in_seconds?: number; resend_after_seconds?: number }; message?: string }>(
    "/api/auth/otp/request/",
    { mobile, purpose },
  );

export const otpLogin = (mobile: string, code: string) =>
  request<Record<string, any>>("/api/auth/otp/login/", { mobile, code });

export const otpSignup = (data: {
  mobile: string;
  code: string;
  username: string;
  password: string;
  email?: string;
  full_name?: string;
}) => request<Record<string, any>>("/api/auth/otp/signup/", data);

export const resetPasswordWithOtp = (mobile: string, code: string, newPassword: string) =>
  request<Record<string, any>>("/api/auth/otp/password-reset/", {
    mobile,
    code,
    new_password: newPassword,
  });
